import { Settings } from './Settings.component';
import { withRouter } from 'react-router-dom';

export default withRouter(Settings);
